<script lang="ts">
    import Thermometer from "../../../public/icons/thermometer.svelte";
    import { conditions, cType, Observation, Widget, widgetInfo, WidgetType } from "../../store";

    export let isPrimaryCondition: boolean = false;

    let fill = "--default-color"
    let errorFill = "--error-color"
    let threshold = undefined;
    let conditionValue = 70;

    widgetInfo.subscribe((value: Widget) => {
        if (value && value.widgetConditions) {
            if(value.type != WidgetType.DEF && isPrimaryCondition){
                fill = "--primary-color"
            }
            if (isPrimaryCondition && value.policies) { // NPA
                threshold = value.primaryThreshold;
            } else {
                const currentConditions = value.widgetConditions;
                const temperatureCondition = currentConditions.find(
                    condition => condition.conditionType === cType.TEMP
                );
                if (temperatureCondition) {
                    threshold = temperatureCondition.threshold;
                }
            }
        }
    });

    conditions.subscribe((value: Observation) => {
        let temp = 70;//default temp value to widget has something to display without an org loc.
        if(value){
            const ambientTemp = value.ambientTemperature.value;
            temp = Math.round(ambientTemp);
        }
        if(threshold != undefined && temp >= threshold)
                fill = errorFill;
        conditionValue = temp;
    });

</script>

<div class="cc-container" style="color: var({fill});">
    {#if !isPrimaryCondition}
      <div class="weatherIcon">
        <Thermometer fill="var({fill})"/>
      </div>
    {/if}

      <div class="{isPrimaryCondition ? "primary-value":"value"}">{conditionValue}&deg;</div>

      <!-- {#if !isPrimaryCondition}
        <div class="cc-label">
          <div class="{isPrimaryCondition ? "primary-label" : "label"}">{@html label}</div>
          <div class="hidden-unit">{@html unitDisplay}</div>
        </div> -->
      <!-- {/if} -->
    <div class="{isPrimaryCondition ? "primary-label" : "label"}">Temp</div>

    

  </div>
